import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Label } from '@lichtblick/ui-components';
import { Divider, Row, Rows, SecondRow, Value } from './Listing.styles';
const SingleRow = ({ title, value, valueColor })=>/*#__PURE__*/ _jsxs(Row, {
        children: [
            /*#__PURE__*/ _jsx(Label, {
                isBold: true,
                size: "S",
                children: title
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsx(Value, {
                $color: valueColor,
                size: "S",
                children: value
            })
        ]
    });
const DoubleRow = ({ subValue, subtitle, title, value, valueColor })=>/*#__PURE__*/ _jsxs("span", {
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        isBold: true,
                        size: "S",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    /*#__PURE__*/ _jsx(Value, {
                        $color: valueColor,
                        size: "S",
                        children: value
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(SecondRow, {
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        isBold: true,
                        size: "S",
                        children: subtitle
                    }),
                    /*#__PURE__*/ _jsx(Value, {
                        $color: valueColor,
                        size: "S",
                        children: subValue
                    })
                ]
            })
        ]
    });
const toRowElementNew = (row)=>{
    const key = `${row.title}-${row.value}`;
    return row.subtitle || row.subValue ? /*#__PURE__*/ _createElement(DoubleRow, {
        ...row,
        key: key
    }) : /*#__PURE__*/ _createElement(SingleRow, {
        ...row,
        key: key
    });
};
export const Listing = ({ backgroundColor, 'data-testid': testId, rows })=>/*#__PURE__*/ _jsx(Rows, {
        $backgroundColor: backgroundColor,
        "data-testid": testId,
        children: rows?.map(toRowElementNew)
    });

//# sourceMappingURL=Listing.js.map